export const decorateOrderId = (orderId: number): string => `SPL${orderId}`

/**
 * Inverse of {@link decorateOrderId}: extracts the numeric `orderId` from a
 * decorated order number (e.g. `"SPL155"` → `155`).
 *
 * Returns `null` when the input isn't a valid decorated order number, so
 * callers parsing untrusted values (e.g. webhook payloads) can decide how to
 * handle the mismatch.
 */
export const undecorateOrderId = (orderNumber: string): number | null => {
  const match = orderNumber.match(/^SPL(\d+)$/)
  return match ? Number(match[1]) : null
}
